<script>
import CommonService from '../../services/common';
import Service from '../../services/vessel-protocol';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';
import Utils from '../../common/Utils';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
export default{
  components: {
    ResponsiveButton,
    ColumnGroup,
    Row
  },
  data(){
    return {
      selectedItem: null,
      limsDetailsDialogVisible: false,
      limsAnalysis: [],
      limsDetailsDialog: {
        selectedSample: ''
      },
      editCellVisible: false,
      cellToEdit: {
        recordId: null,
        propertyName: null,
        propertyDecimalValue: null,
        propertyStringValue: null,
        propertyBooleanValue: null
      },
      addNoteVisible: false,
      noteVisible: false,
      currentCell: null,
      dataOriginSample: [],
      dataLoadingPort: [],
      notes: [],
      loadingOriginSample: false,
      loadingLoadingPort: false,
      newNote: {
        description: '',
        colorHex: 'ff0000'
      },
      filters: {
        referenceDate:  Utils.setDay(new Date(), 1),
        vesselName: ''
      },
      columns: [
        {type: 'boolean', name: 'isRecordProcessed', trueValue: 'OK', falseValue: ''},
        {type: 'string', name: 'rawMaterial', canEdit: true},
        {type: 'string', name: 'grade', canEdit: true},
        {type: 'string', name: 'voyageNumber', canEdit: false},
        {type: 'string', name: 'vesselName', canEdit: false},
        {type: 'string', name: 'analysisSampleNumber', isAnalysisSample: true},
        {type: 'decimal', digit: 1, name:'barrelDensity', hasNote: true, canEdit: true, hasComment: true},
        {type: 'decimal', digit: 2, name:'barrelSulphurPercentage', hasNote: true, canEdit: true, hasComment: true},

        {type: 'decimal', digit: 1, name:'analysisDensity', hasNote: true, canEdit: true, hasComment: true},
        {type: 'decimal', digit: 2, name:'analysisSulphurPercentage', hasNote: true, canEdit: true, hasComment: true},

        {type: 'decimal', digit: 1, name:'barrelVsAnalysisDensityDelta', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 2, name:'barrelVsAnalysisSulphurPercentageDelta', hasNote: false, canEdit: false},

        {type: 'decimal', digit: 1, name:'analysisAvgDensityX', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 1, name:'analysisAvgDensityR', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 1, name:'analysisAvgDensityPlus2R', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 1, name:'analysisAvgDensityMinus2R', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 1, name:'analysisAvgDensityResult', hasNote: false, canEdit: false},
        {type: 'boolean', name:'analysisAvgDensityOk', trueValue: 'OK', falseValue: '', isResult: true},

        {type: 'decimal', digit: 3, name:'analysisAvgSulphurPercentageX', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 3, name:'analysisAvgSulphurPercentageR', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 3, name:'analysisAvgSulphurPercentagePlus2R', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 3, name:'analysisAvgSulphurPercentageMinus2R', hasNote: false, canEdit: false},
        {type: 'decimal', digit: 3, name:'analysisAvgSulphurPercentageResult', hasNote: false, canEdit: false},
        {type: 'boolean', name: 'analysisAvgSulphurPercentageResultOk', trueValue: 'OK', falseValue: '', isResult: true}
      ],
      uploadVisible: false,
      copyNoteVisible: false,
      copyNotesData: {
        referenceDate: null
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
    noteMap(){
      let map = {};

      if(this.notes && this.notes.length > 0){
        this.notes.forEach(e => {
          map[e.id] = e.colorHex;
        })
      }

      return map;
    }
  },
  created(){
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'RawMaterialCheck.page_title');
  },
  methods: {
    formatInteger(n){
        if(n || n == 0){
            return n.toLocaleString();
        }
        return null;
    },
    formatDecimal(n, digits, showZero){
        if(!digits){
            digits = 2;
        }
        if(n){
            return n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits});
        }
        return showZero ? 0 : null;
        
    },
     load(){
        this.loadGrid('OriginSample');
        this.loadGrid('LoadingPort');
        this.loadNotes();
    },
    loadGrid(checkType){
      let filters = {
        referenceDate: this.filters.referenceDate ? Utils.formatDateForAPI(this.filters.referenceDate) : null,
        checkType: checkType,
        vesselName: this.filters.vesselName,
        isDeleted: false
      }
      if(checkType == 'OriginSample'){
        this.loadingOriginSample = true;
        this.dataOriginSample = [];
      }else{
        this.loadingLoadingPort = true;
        this.dataLoadingPort = [];
      }
      Service.loadDischargeRawMaterialCheck(filters, response => {
        if(checkType == 'OriginSample'){
          this.loadingOriginSample = false;
          this.dataOriginSample = response.success ? response.data : [];
        }else{
          this.loadingLoadingPort = false;
          this.dataLoadingPort =response.success ? response.data : [];
        }
      });
    },
    loadNotes(){
      let filters = {
        referenceDate: Utils.formatDateForAPI(this.filters.referenceDate),
      }
      this.notes = [];
      Service.loadDischargeRawMaterialCheckNote(filters, response => {
        if(response.success){
          this.notes = response.data;
        }
      });

    },
    showNotes(item, field, col){
      this.currentCell = {
        item: item,
        field: field,
        col: col
      };
      this.noteVisible = true;
    },
    editCell(item, field, col){
      this.cellToEdit = {
        recordId: null,
        propertyName: null,
        propertyDecimalValue: null,
        propertyStringValue: null,
        propertyBooleanValue: false
      };
      this.currentCell = {
        item: item,
        field: field,
        col: col
      };
      this.editCellVisible = true;
    },
    addNewNote(){
      this.newNote = {
        description: '',
        colorHex: 'ff0000'
      };
      this.addNoteVisible= true;
    },
    saveNewNote(){
      let item = {
        colorHex: this.newNote.colorHex,
        description: this.newNote.description,
        referenceDate: Utils.formatDateForAPI(this.filters.referenceDate)
      }
      Service.createDischargeRawMaterialCheckNote(item, response => {
        if(response.success){
          this.loadNotes();
          this.addNoteVisible= false;
        }else{
          this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      });
    },
    saveEditCell(){
      let f = this.currentCell.field.charAt(0).toUpperCase() + this.currentCell.field.slice(1);
      let body = {
        recordId: this.currentCell.item.id,
        propertyName: f,
        propertyDecimalValue: this.cellToEdit.propertyDecimalValue,
        propertyStringValue: this.cellToEdit.propertyStringValue,
        propertyBooleanValue: this.cellToEdit.propertyBooleanValue
      };

       Service.updateRawMaterialCheck(body, response => {
          if(response.success){
              this.load();
              this.editCellVisible = false;
          }else{
            this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        });
    },
    associateNote(id){
      this.$confirm.require({
          message: id ? this.$t('RawMaterialCheck.associateNoteQuestion') : this.$t('RawMaterialCheck.deleteNoteAssociation'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('yes'),
          rejectLabel: this.$t('no'),
          accept: () => {
            let f = this.currentCell.field.charAt(0).toUpperCase() + this.currentCell.field.slice(1) + 'NoteId';
            let body = {
              noteId: id,
              rawMaterialCheckRecordId: this.currentCell.item.id,
              rawMaterialCheckRecordProperty: f
            };
            
            Service.dischargeRawMaterialCheckAssociateNote(body, response => {
              if(response.success){
                  this.load();
                  this.noteVisible = false;
              }else{
                this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            });
          },
          reject: () => {
              //callback to execute when user rejects the action
              this.$confirm.close();
          }
      });
    },
    importAnalysisSample(item){
      this.selectedItem = item;
      this.performImport({
        idVesselProtocol: item.idVesselProtocol
      });
    },
    performImport(body){
      this.$store.dispatch("generic/setLoading", true);
      Service.rawMaterialCheckImportAnalysisValues(body, response => {
        this.$store.dispatch("generic/setLoading", false);
        this.limsDetailsDialog.selectedSample = {};
        if(response.success){
          let data = response.data;
          if(body.sampleNumber){
            this.$toast.add({detail: this.$t('RawMaterialCheck.analysisValuesImportSuccess'), life: 3000, severity: 'success'});
            this.load();
          }else{
            for(let i=0; i<data.length; i++){
              data[i].dataPrelievo = Utils.formatDateTime(new Date(data[i].dataPrelievo));
            }
            this.limsAnalysis = data;
            this.limsDetailsDialogVisible = true;
          }
        }else if(response.notFound){
          this.$toast.add({ detail: this.$t('RawMaterialCheck.analysisValuesImportNotFound'), life: 3000, severity: 'error' });
        }else{
          this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    associateOriginSample(){
      this.performImport({
        idVesselProtocol: this.selectedItem.idVesselProtocol,
        sampleNumber: this.limsDetailsDialog.selectedSample.numeroCampione
      });
      this.limsDetailsDialogVisible = false;
    },
    validate(item){
        this.$confirm.require({
          message: this.$t('RawMaterialCheck.validateMessage'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('RawMaterialCheck.done'),
          rejectLabel: this.$t('RawMaterialCheck.undone'),
          accept: () => {
            let body = {
              recordId: item.id,
              propertyName: 'IsRecordProcessed',
              propertyBooleanValue: true
            };

            Service.updateRawMaterialCheck(body, response => {
                if(response.success){
                    this.load();
                }else{
                  this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
              });
          },
          reject: () => {
            let body = {
              recordId: item.id,
              propertyName: 'IsRecordProcessed',
              propertyBooleanValue: false
            };

            Service.updateRawMaterialCheck(body, response => {
                if(response.success){
                  this.$confirm.close();
                    this.load();
                }else{
                  this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
              });
              
          }
      });
    },
    downloadExcel(){
      let date = this.filters.referenceDate ? Utils.formatDateForAPI(this.filters.referenceDate) : null;
      let fileName = date != null ? date : this.filters.vesselName;
      let params = {
        referenceDate: date,
        vesselName: this.filters.vesselName,
      }
      this.$store.dispatch("generic/setLoading", true);
        Service.dischargeRawMaterialDownload(params, response => {

            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Verifica Materia Prima_'+ fileName + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            } else {
                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    },
    
    onUpload(file){
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
      });
      file.files.forEach( async (document) => {
        const base64 = await toBase64(document);

        let formData = {
          idVesselProtocol: this.selectedItemForUpload.idVesselProtocol,
          section: 'DischargeTracking',
          description: document.name,
          documentType: "Certificato di Qualita'",
          fileNameWithExtension: document.name,
          fileContentBase64: base64,
        }
        this.$store.dispatch("generic/setLoading", true);
  
        Service.addDocumentVesselProtocolDocumentManager(formData, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.uploadVisible = false;
            this.itemUpload = null;
            this.$toast.add({detail: this.$t('messages.upload_message_success'), life:3000, severity:'success'});
            this.load();
          }else{
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      })
    },
    openUploadQualityCertificate(item){
      this.selectedItemForUpload = item;
      this.uploadVisible = true; 
    },
    
    downloadQualityCertificate(documentGuid, fileNameWithExtension){
      this.$store.dispatch("generic/setLoading", true);
      Service.downloadDocumentVesselProtocol({documentGuid: documentGuid, fileNameWithExtension: fileNameWithExtension }, ({success, data, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        
        if(success){
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', fileNameWithExtension);
          document.body.appendChild(fileLink);
      
          fileLink.click();
        } else{
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    openCopyNotes(){
      this.copyNotesData.referenceDate = null;
      this.copyNoteVisible = true
    },
    copyNotes(){
      this.$confirm.require({
          message: this.$t('RawMaterialCheck.copyNotesQuestion'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('yes'),
          rejectLabel: this.$t('no'),
          accept: () => {
            
            let fromReferenceDate = Utils.formatDateForAPI(this.copyNotesData.referenceDate);
            let toReferenceDate = Utils.formatDateForAPI(this.filters.referenceDate)
            
            Service.rawMaterialCheckCloneNotes(fromReferenceDate, toReferenceDate, response => {
              if(response.success){
                this.copyNoteVisible = false;
                this.loadNotes();
              }else{
                this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            });
          },
          reject: () => {
              //callback to execute when user rejects the action
              this.$confirm.close();
          }
      });
    }
  }
}

</script>

<template>
  <main>
    <Dialog v-model:visible="uploadVisible" modal>
        <template #header>
            <h3>{{$t('DischargeTrackingReport.upload')}}</h3>
        </template>
        <FileUpload name="uploaded[]" :customUpload="true" @uploader="onUpload" :previewWidth="0" :fileLimit="1" :multiple="false" />                    
    </Dialog> 
    <Dialog v-model:visible="limsDetailsDialogVisible" modal closable :style="{width: '85vw'}" >
        <div class="grid" >
            <div class="col-12 field">
                <label>{{$t('limsInterface.sampleNumber')}}</label>
                <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="limsDetailsDialog.selectedSample" :options="limsAnalysis" optionLabel="numeroCampione" />
            </div>
        </div>
        <!-- {{limsDetailsDialog.selectedSample}} -->
        <div class="grid" >
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.type')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.tipologia" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.puntoPrelievo')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.puntoPrelievo" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.sito')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.sito" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.categoria')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.categoria" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.codiceProdotto')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.codiceProdotto" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.prodotto')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.prodotto" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.dataPrelievo')}}</label>
                <Calendar :placeholder="constants.DATE_PLACEHOLDER_POINT"
                  :dateFormat="constants.DATE_FORMAT_POINT"
                  :showTime="true"
                  readonly
                  id="laycanEndDate" 
                  v-model="limsDetailsDialog.selectedSample.dataPrelievo"
                  :class="{'w-full p-inputtext-sm mt-1 ': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.viaggio')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.viaggio" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
                <label>{{$t('limsInterface.nave')}}</label>
                <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.nave" :class="{'w-full p-inputtext-sm': true}" />
            </div>

            <div class="col-12 lg:col-4 field">
              <label style="font-weight: bold;">{{$t('RawMaterialCheck.barrelDensity')}}</label>
              <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.barrelDensity15StringValue" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
              <label style="font-weight: bold;">{{$t('RawMaterialCheck.barrelApiGrade')}}</label>
              <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.barrelApiGradeStringValue" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
              <label style="font-weight: bold;">{{$t('RawMaterialCheck.barrelSulphurContent')}}</label>
              <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.barrelSulphurContentStringValue" :class="{'w-full p-inputtext-sm': true}" />
            </div>

            

            <div class="col-12 lg:col-4 field">
              <label style="font-weight: bold;">{{$t('RawMaterialCheck.originSampleDensity')}}</label>
              <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.originSampleDensity15StringValue" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
              <label style="font-weight: bold;">{{$t('RawMaterialCheck.originSampleApiGrade')}}</label>
              <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.originSampleApiGradeStringValue" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-4 field">
              <label style="font-weight: bold;">{{$t('RawMaterialCheck.originSampleSulphurContent')}}</label>
              <InputText type="text" readonly v-model="limsDetailsDialog.selectedSample.originSampleSulphurContentStringValue" :class="{'w-full p-inputtext-sm': true}" />
            </div>
        </div>
        <template #footer>
            <Button :label="$t('btn.link')" icon="pi pi-link" @click="associateOriginSample" autofocus />
        </template>
    </Dialog>
    <Dialog v-model:visible="editCellVisible" :modal="true" >
        <div class="grid">
          <div class="col-12 field">
            <label>{{$t('RawMaterialCheck.oldValue')}}</label>
            <InputText class="w-full" readonly v-model="currentCell.item[currentCell.field]"  />
          </div>
          
          <div class="col-12 field">
            <label>{{$t('RawMaterialCheck.newValue')}}</label>
            <InputNumber class="w-full" v-model="cellToEdit.propertyDecimalValue" v-if="currentCell.col.type == 'decimal' && currentCell.field.indexOf('Comment') == -1" mode="decimal" :maxFractionDigits="currentCell.col.digit" />
            <InputText class="w-full" v-model="cellToEdit.propertyStringValue" v-if="currentCell.col.type == 'string' || currentCell.field.indexOf('Comment') != -1" />
          </div>
        </div>
        <template #footer>
          <Button :label="$t('btn.save')" icon="pi pi-save" @click="saveEditCell" autofocus />
      </template>
     </Dialog>
     <Dialog v-model:visible="addNoteVisible" :modal="true" >
        <div class="grid">
          <div class="col-12">
            <label>{{$t('description')}}</label>
            <Textarea
              class="w-full"
              v-model="newNote.description" />
          </div>
          <div class="col-12">
            <label>{{$t('RawMaterialCheck.color')}}</label>
            <ColorPicker class="w-full" v-model="newNote.colorHex" />
          </div>
        </div>
        <template #footer>
          <Button :label="$t('btn.save')" icon="pi pi-save" @click="saveNewNote" autofocus />
      </template>
     </Dialog>
     <Dialog v-model:visible="copyNoteVisible" :modal="true" >
        <div class="grid">
          <div class="col-12 field">
              <label for="referenceDate">{{$t('RawMaterialCheck.copyFrom')}}</label>
              <Calendar
              view="month" dateFormat="mm/yy"
                  :class="{'p-inputtext-sm w-full': true}"
                  :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                  :showTime="false"
                  v-model="copyNotesData.referenceDate"
                  :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          </div>
        <template #footer>
          <Button :label="$t('btn.copy')" icon="pi pi-copy" @click="copyNotes" autofocus />
      </template>
     </Dialog>
     <Dialog v-model:visible="noteVisible" :modal="true" :style="{width: '85vw'}">
      <div class="grid">
        <div class="col-12">
          <Button :label="$t('btn.delete')" icon="pi pi-trash" @click="associateNote(null)" autofocus />
        </div>
        <div v-for="note in notes" :key="note.id" class="col-6" >
          <div 
            @click="associateNote(note.id)"
            :style="{backgroundColor: '#'+note.colorHex, padding:'5px', border: currentCell.item[currentCell.field + 'NoteId'] == note.id ? '1px solid black' : false, cursor:'pointer'}">
            {{note.description}}
          </div>
        </div>
      </div>
    </Dialog>
    <div class="grid">
        <div class="col-12 lg:col-2 field">
            <label for="referenceDate">{{$t('RawMaterialCheck.referenceDate')}}</label>
            <Calendar
            view="month" dateFormat="mm/yy"
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-2 field">
            <label for="referenceDate">{{$t('RawMaterialCheck.vesselName')}}</label>
            <InputText class="w-full" v-model="filters.vesselName" />

        </div>

        <div class="col-12 lg:col-6 field">
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="mx-1" @click="load()"/>
                <ResponsiveButton :label="$t('btn.download')" icon="pi pi-file-excel" class="mx-1" @click="downloadExcel()"/>
            </div>
        </div>
        <div class="col-12" style="height: calc(75vh)">
          <TabView >
            <TabPanel :header="$t('RawMaterialCheck.originSample')">
              <div style="height: calc(65vh)">
              <DataTable scrollable showGridlines :value="dataOriginSample" :reorderableColumns="true" :loading="loadingOriginSample" >
                 <ColumnGroup type="header" >
                    <Row>
                      <Column :header="''" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.isRecordProcessed')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.rawMaterial')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.grade')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.voyageNumber')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.vesselName')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.analysisSampleNumber')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.sample')" :colspan="2" />
                      <Column :header="$t('RawMaterialCheck.originSampleHeader')" :colspan="2" />
                      <Column :header="$t('RawMaterialCheck.differenceSampleVsOriginSample')" :colspan="2" />
                      <Column :header="$t('RawMaterialCheck.density')" :colspan="6" />
                      <Column :header="$t('RawMaterialCheck.sulphur')" :colspan="6" />
                    </Row>
                    <Row>
                      <Column :header="$t('RawMaterialCheck.uomDensity')" sortable field="barrelDensity" />
                      <Column :header="$t('RawMaterialCheck.uomSulphur')" sortable field="barrelSulphurPercentage" />

                      <Column :header="$t('RawMaterialCheck.uomDensity')" sortable field="analysisDensity" />
                      <Column :header="$t('RawMaterialCheck.uomSulphur')" sortable field="analysisSulphurPercentage" />

                      <Column :header="$t('RawMaterialCheck.uomDensity')" sortable field="barrelVsAnalysisDensityDelta" />
                      <Column :header="$t('RawMaterialCheck.uomSulphur')" sortable field="barrelVsAnalysisSulphurPercentageDelta" />

                      <Column :header="$t('RawMaterialCheck.x')" sortable field="analysisAvgDensityX" />
                      <Column :header="$t('RawMaterialCheck.r')" sortable field="analysisAvgDensityR" />
                      <Column :header="$t('RawMaterialCheck.plus2R')" sortable field="analysisAvgDensityPlus2R" />
                      <Column :header="$t('RawMaterialCheck.minus2R')" sortable field="analysisAvgDensityMinus2R" />
                      <Column :header="$t('RawMaterialCheck.result')" sortable field="analysisAvgDensityResult" />
                      <Column :header="$t('RawMaterialCheck.ok')" sortable field="analysisAvgDensityOk" />

                      <Column :header="$t('RawMaterialCheck.x')" sortable field="analysisAvgSulphurPercentageX" />
                      <Column :header="$t('RawMaterialCheck.r')" sortable field="analysisAvgSulphurPercentageR" />
                      <Column :header="$t('RawMaterialCheck.plus2R')" sortable field="analysisAvgSulphurPercentagePlus2R" />
                      <Column :header="$t('RawMaterialCheck.minus2R')" sortable field="analysisAvgSulphurPercentageMinus2R" />
                      <Column :header="$t('RawMaterialCheck.result')" sortable field="analysisAvgSulphurPercentageResult" />
                      <Column :header="$t('RawMaterialCheck.ok')" sortable field="analysisAvgSulphurPercentageResultOk" />
                    </Row>
                  </ColumnGroup>
                  <Column class="button-column" :exportable="false" :style="{width: '150px', padding: 0}"  >
                    <template #body="{data}">
                      <div :style="{textAlign: 'center', padding: '5px', fontWeight: 'bold'}" class="w-full">
                         <div class="grid " style="margin-top: 0px">
                          <div class="col-12" style="align-self: center;">
                           <Button icon="fa-solid fa-flask" class="p-button-sm p-button-rounded p-button-success m-1" v-tooltip="$t('RawMaterialCheck.importSample')" @click="importAnalysisSample(data)"  />
                           <Button icon="fa-solid fa-check" class="p-button-sm p-button-rounded p-button-success m-1" v-tooltip="$t('RawMaterialCheck.validate')" @click="validate(data)"  />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column v-for="col in columns" :key="col.name" :field="col.name" :style="{minWidth: '150px', padding: 0}">
                    <template #body="{data}">
                      <div :style="{backgroundColor: '#'+ noteMap[data[col.name+'NoteId']], textAlign: 'center', padding: '5px', fontWeight: 'bold'}" class="w-full" v-tooltip="data[col.name + 'Comment']">
                        <div class="grid " style="margin-top: 0px">
                          <div class="col-12" style="align-self: center;">
                            <span v-if="col.type == 'boolean'">
                              <p v-if="col.isResult" :style="{backgroundColor: data[col.name] ? 'green' : 'red', height: '30px', width: '30px', borderRadius: '50%', margin: 'auto'}" />
                              <i v-else :class="{'fa-solid fa-check-circle text-green-400': data[col.name]}" style="font-size: 25px"></i>
                            </span>
                            <span v-else-if="col.type == 'decimal'" type="text" placeholder="Right" >
                              <p v-if="data[col.name]">
                              {{formatDecimal(data[col.name], col.digit)}}
                              </p>
                              <p v-else-if="data[col.name+'OriginalTextValue']">
                                {{data[col.name+'OriginalTextValue']}}
                              </p>
                            </span>
                            <p v-else type="text" placeholder="Right" >
                              {{data[col.name]}}
                            </p>
                            
                          </div>
                          <div class="col-12">
                              <Button v-if="col.canEdit" icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-1" v-tooltip="$t('btn.edit')" @click="editCell(data, col.name, col)"  />
                            <Button v-if="col.hasComment" icon="pi pi-comment" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-1" v-tooltip="$t('btn.comment')" @click="editCell(data, col.name+'Comment' , col)"  />
                            <Button v-if="col.hasNote" icon="pi pi-folder" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-1" v-tooltip="$t('note')" @click="showNotes(data, col.name, col)"  />
                            <!-- <span v-if="col.isAnalysisSample">
                              <Button icon="pi pi-sync" class="p-button-sm p-button-rounded p-button-success mr-1 mb-1" v-tooltip="$t('note')" @click="importAnalysisSample(data)"  />
                            </span> -->
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <template #footer>
                    <p>Notes</p>
                    <Button :label="$t('btn.add')" icon="pi pi-plus" class="m-4 p-button-outlined" @click="addNewNote"  />
                    <Button :label="$t('btn.copy')" icon="pi pi-copy" class="m-4 p-button-outlined" @click="openCopyNotes"  />
                    <div class="grid">
                      <div v-for="note in notes" :key="note.id" class="col-6">
                        <div :style="{backgroundColor: '#'+note.colorHex, padding:'5px', border: '1px solid black'}">
                          {{note.description}}
                        </div>
                      </div>
                    </div>
                  </template>
              </DataTable>
              </div>
            </TabPanel>
            <TabPanel :header="$t('RawMaterialCheck.loadingPort')">
              <DataTable scrollable showGridlines :value="dataLoadingPort" :reorderableColumns="true" :loading="loadingLoadingPort">
                 <ColumnGroup type="header" >
                    <Row>
                      <Column :header="''" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.isRecordProcessed')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.rawMaterial')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.grade')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.voyageNumber')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.vesselName')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.analysisSampleNumber')" :rowspan="2" />
                      <Column :header="$t('RawMaterialCheck.sample')" :colspan="2" />
                      <Column :header="$t('RawMaterialCheck.loadingPortHeader')" :colspan="2" />
                      <Column :header="$t('RawMaterialCheck.differenceSampleVsLoadingPortSample')" :colspan="2" />
                      <Column :header="$t('RawMaterialCheck.density')" :colspan="6" />
                      <Column :header="$t('RawMaterialCheck.sulphur')" :colspan="6" />
                    </Row>
                    <Row>
                      <Column :header="$t('RawMaterialCheck.uomDensity')" sortable field="barrelDensity" />
                      <Column :header="$t('RawMaterialCheck.uomSulphur')" sortable field="barrelSulphurPercentage" />

                      <Column :header="$t('RawMaterialCheck.uomDensity')" sortable field="analysisDensity" />
                      <Column :header="$t('RawMaterialCheck.uomSulphur')" sortable field="analysisSulphurPercentage" />

                      <Column :header="$t('RawMaterialCheck.uomDensity')" sortable field="barrelVsAnalysisDensityDelta" />
                      <Column :header="$t('RawMaterialCheck.uomSulphur')" sortable field="barrelVsAnalysisSulphurPercentageDelta" />

                      <Column :header="$t('RawMaterialCheck.x')" sortable field="analysisAvgDensityX" />
                      <Column :header="$t('RawMaterialCheck.r')" sortable field="analysisAvgDensityR" />
                      <Column :header="$t('RawMaterialCheck.plus2R')" sortable field="analysisAvgDensityPlus2R" />
                      <Column :header="$t('RawMaterialCheck.minus2R')" sortable field="analysisAvgDensityMinus2R" />
                      <Column :header="$t('RawMaterialCheck.result')" sortable field="analysisAvgDensityResult" />
                      <Column :header="$t('RawMaterialCheck.ok')" sortable field="analysisAvgDensityOk" />

                      <Column :header="$t('RawMaterialCheck.x')" sortable field="analysisAvgSulphurPercentageX" />
                      <Column :header="$t('RawMaterialCheck.r')" sortable field="analysisAvgSulphurPercentageR" />
                      <Column :header="$t('RawMaterialCheck.plus2R')" sortable field="analysisAvgSulphurPercentagePlus2R" />
                      <Column :header="$t('RawMaterialCheck.minus2R')" sortable field="analysisAvgSulphurPercentageMinus2R" />
                      <Column :header="$t('RawMaterialCheck.result')" sortable field="analysisAvgSulphurPercentageResult" />
                      <Column :header="$t('RawMaterialCheck.ok')" sortable field="analysisAvgSulphurPercentageResultOk" />
                    </Row>
                  </ColumnGroup>
                  <Column class="button-column" :exportable="false" :style="{width: '150px', padding: 0}"  >
                    <template #body="{data}">
                      <div :style="{textAlign: 'center', padding: '5px', fontWeight: 'bold'}" class="w-full">
                         <div class="grid " style="margin-top: 0px">
                          <div class="col-12" style="align-self: center;">
                           <Button icon="fa-solid fa-flask" class="p-button-sm p-button-rounded p-button-success m-1" v-tooltip="$t('RawMaterialCheck.importSample')" @click="importAnalysisSample(data)"  />
                           <Button icon="fa-solid fa-check" class="p-button-sm p-button-rounded p-button-success m-1" v-tooltip="$t('RawMaterialCheck.validate')" @click="validate(data)"  />
                           <Button icon="fa-solid fa-download" class="p-button-sm p-button-rounded p-button-success m-1" v-tooltip="$t('btn.download')" @click="downloadQualityCertificate(data.qualityCertificateDocumentGuid, data.qualityCertificateDocumentFileName)" v-if="data.qualityCertificateDocumentGuid" />
                           <Button icon="fa-solid fa-upload" class="p-button-sm p-button-rounded p-button-success m-1" v-tooltip="$t('btn.upload')" @click="openUploadQualityCertificate(data)"  />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <Column v-for="col in columns" :key="col.name" :field="col.name" :style="{minWidth: '150px', padding: 0}">
                    <template #body="{data}">
                      <div :style="{backgroundColor: '#'+ noteMap[data[col.name+'NoteId']], textAlign: 'center', padding: '5px', fontWeight: 'bold'}" class="w-full" v-tooltip="data[col.name + 'Comment']">
                        <div class="grid " style="margin-top: 0px">
                          <div class="col-12" style="align-self: center;">
                            <span v-if="col.type == 'boolean'">
                              <p v-if="col.isResult" :style="{backgroundColor: data[col.name] ? 'green' : 'red', height: '30px', width: '30px', borderRadius: '50%', margin: 'auto'}" />
                              <i v-else :class="{'fa-solid fa-check-circle text-green-400': data[col.name]}" style="font-size: 25px"></i>
                            </span>
                            <span v-else-if="col.type == 'decimal'" type="text" placeholder="Right" >
                              <p v-if="data[col.name]">
                              {{formatDecimal(data[col.name], col.digit)}}
                              </p>
                              <p v-else-if="data[col.name+'OriginalTextValue']">
                                {{data[col.name+'OriginalTextValue']}}
                              </p>
                            </span>
                            <p v-else type="text" placeholder="Right" >
                              {{data[col.name]}}
                            </p>
                            
                          </div>
                          <div class="col-12">
                              <Button v-if="col.canEdit" icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-1" v-tooltip="$t('btn.edit')" @click="editCell(data, col.name, col)"  />
                            <Button v-if="col.hasComment" icon="pi pi-comment" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-1" v-tooltip="$t('btn.comment')" @click="editCell(data, col.name+'Comment' , col)"  />
                            <Button v-if="col.hasNote" icon="pi pi-folder" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-1" v-tooltip="$t('note')" @click="showNotes(data, col.name, col)"  />
                            <!-- <span v-if="col.isAnalysisSample">
                              <Button icon="pi pi-sync" class="p-button-sm p-button-rounded p-button-success mr-1 mb-1" v-tooltip="$t('note')" @click="importAnalysisSample(data)"  />
                            </span> -->
                          </div>
                        </div>
                      </div>
                    </template>
                  </Column>
                  <template #footer>
                    <p>Notes</p>
                    <Button :label="$t('btn.add')" icon="pi pi-plus" class="m-4 p-button-outlined" @click="addNewNote"  />
                    <Button :label="$t('btn.copy')" icon="pi pi-copy" class="m-4 p-button-outlined" @click="openCopyNotes"  />
                    <div class="grid">
                      <div v-for="note in notes" :key="note.id" class="col-6">
                        <div :style="{backgroundColor: '#'+note.colorHex, padding:'5px', border: '1px solid black'}">
                          {{note.description}}
                        </div>
                      </div>
                    </div>
                  </template>
              </DataTable>
            </TabPanel>
          </TabView>
        </div>

    </div>
  </main>
</template>